var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTechnologyIcon = function SvgTechnologyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#technology_icon_svg__a)",
    d: "M13 34v-5.55a2.25 2.25 0 0 0-2.25-2.25H10v-2.4h.75A2.25 2.25 0 0 0 13 21.55V16a4.5 4.5 0 0 1 4.5-4.5H19v3h-1.5A1.5 1.5 0 0 0 16 16v6.15A3 3 0 0 1 13.939 25 3 3 0 0 1 16 27.85V34a1.5 1.5 0 0 0 1.5 1.5H19v3h-1.5A4.5 4.5 0 0 1 13 34m24-5.55V34a4.5 4.5 0 0 1-4.5 4.5H31v-3h1.5A1.5 1.5 0 0 0 34 34v-6.15A3 3 0 0 1 36.061 25 3 3 0 0 1 34 22.15V16a1.5 1.5 0 0 0-1.5-1.5H31v-3h1.5A4.5 4.5 0 0 1 37 16v5.55a2.25 2.25 0 0 0 2.25 2.25H40v2.4h-.75A2.25 2.25 0 0 0 37 28.45"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "technology_icon_svg__a",
    x1: 10,
    x2: 40,
    y1: 25,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D52F4",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7D52F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D52F4",
    stopOpacity: 0.8
  })))));
};
export default SvgTechnologyIcon;